module.exports = __webpack_public_path__ + "img/rules_title.7f07bfa2.png";